<div class="w-full bg-white">

    <!-- Header -->
    <div class="flex flex-row  justify-between items-center py-3 px-4 md:px-8 border-b">

        <!-- Title -->
        <div class="w-full flex items-center">
            <arrow-back></arrow-back>
            <div>
                <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">Coleccionistas</div>
                <div class="ml-0.5 font-medium text-secondary"></div>
            </div>
        </div>

        <!-- Add contact button -->
        <button (click)="agregarColeccionista()"
            *hasPermissions="'boton_agregar_coleccionista' ; modulos ['ListadoGeneralColeccionista']"
            class="ml-4 min-w-28"
            mat-flat-button
            [color]="'primary'">
            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            <span class="ml-2 mr-1">Agregar</span>
        </button>
        
    </div>

    <div class="flex flex-col w-full">
        <!-- Filter -->
        <filtro-coleccionistas></filtro-coleccionistas>
        <!-- Table -->
         <div class="mx-4 md:mx-8 bg-card rounded-2xl shadow mt-2">
            <div class="overflow-y-auto overflow-x-auto p-4">     
                @if(coleccionistas$ | async; as coleccionistas){          
                    <table
                        class="bg-transparent mb-10 mt-2"
                        mat-table
                        matSort
                        [dataSource]="coleccionistas.data"
                        #coleccionistas>
                        <!-- codigo-coleccionista -->
                        <ng-container matColumnDef="id-coleccionista">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                                Código
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                                <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                                    {{coleccionista.coleccionista.codigoColeccionista}}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Nombre -->
                        <ng-container matColumnDef="nombre">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                                Nombre
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                                <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                                    {{ coleccionista?.coleccionista.nombre }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Correo -->
                        <ng-container matColumnDef="correo">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                                Correo
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                                <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                                    {{ coleccionista?.coleccionista.correoElectronico }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Coleccion -->
                        <ng-container matColumnDef="coleccion">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                                Colección
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                                <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                                    {{ coleccionista?.coleccionista.coleccion.descripcion | titlecase }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Departamento -->
                        <ng-container matColumnDef="departamento">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                                Departamento / Municipio
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                            <span class="pr-6 text-sm text-secondary font-medium">
                                    {{ coleccionista?.coleccionista.departamento.descripcion }} / {{ coleccionista?.coleccionista.municipio.descripcion }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- seccion -->
                        <ng-container matColumnDef="seccion">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                                Sección
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                                <status-sticker
                                    [estado]="coleccionista?.coleccionista.seccion.descripcion" 
                                    [color1]="coleccionista?.coleccionista.seccion.valor1" 
                                    [color2]="coleccionista?.coleccionista.seccion.valor2">
                                </status-sticker>
                            </td>
                        </ng-container>

                        <!-- total-bienes -->
                        <ng-container matColumnDef="total-bienes">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                                Total Bienes
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                            <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                                    {{ coleccionista?.cantidadBienesCulturales }}
                                </span>
                            </td>
                        </ng-container>


                        <!-- acciones-->
                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 text-nowrap">
                                
                            </th>
                            <td mat-cell *matCellDef="let coleccionista">
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                    <button mat-menu-item 
                                        *hasPermissions="'agregar_bienes'; modulos ['MenuOpcionesColeccionista']"
                                        (click)="registrarBienCultural(coleccionista)">
                                        <mat-icon>add</mat-icon>
                                        <span>Agregar Bienes</span>
                                    </button>
                                    <button mat-menu-item 
                                        *hasPermissions="'bienes_asociados'; modulos ['MenuOpcionesColeccionista']"
                                        (click)="verBienesAsociados(coleccionista)">
                                        <mat-icon>list</mat-icon>
                                        <span>Bienes Asociados</span>
                                    </button>
                                    <button mat-menu-item 
                                        *hasPermissions="'editar_coleccionista'; modulos ['MenuOpcionesColeccionista']"
                                        (click)="editarColeccionista(coleccionista.coleccionista)">
                                        <mat-icon>edit</mat-icon>
                                        <span>Editar Coleccionista</span>
                                    </button>
      
                                    <button mat-menu-item 
                                        *hasPermissions="'eliminar_coleccionista'; modulos ['MenuOpcionesColeccionista']"
                                        (click)="eliminarColeccionista(coleccionista.coleccionista)">
                                        <mat-icon>delete</mat-icon>
                                        <span>Eliminar Coleccionista</span>
                                    </button>
                                    </mat-menu>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="colecionistasTableColumns" class="bg-slate-100 h-12"></tr>
                        <tr class="order-row h-10 border-y border-gray-200" 
                            mat-row *matRowDef="let row; columns: colecionistasTableColumns;"></tr>
                    </table>
                }
                <mat-paginator [length]="totalResultItems" [pageSize]="this.pageSize" [hidePageSize]="true"></mat-paginator>
            </div>
        </div>
    </div>
    
</div>